import { useNavigate } from 'react-router-dom';
import { Badge, Button } from '../../../components/ui';
import { activeFilter } from '../../../components/common/ListPage/listFilters';
import { Cell, ListPage } from '../../../components/common/ListPage/ListPage';
import { masterOptions } from '../../masters/services/masterService';
import { useMasters } from '../../masters/hooks/useMasters';
import { money } from '../../../utils/currency';

const withGst = (i) => Math.round(((i.sellingRate ?? 0) * (100 + (i.gstRate ?? 0))) / 100);

/** Rate card for point-wise work: wiring points, fittings, repairs, AMC… */
export default function WorkRateList() {
  const navigate = useNavigate();
  useMasters();
  const add = <Button leftIcon="plus" onClick={() => navigate('/work-rates/new')}>Add work rate</Button>;
  return (
    <ListPage
      title="Work rates"
      subtitle="Your rate card for labour and point-wise work, used in quotations and bills"
      path="/items"
      baseQuery={{ type: 'service' }}
      exportName="work-rates"
      filters={[{ key: 'category', label: 'Category', icon: 'grid', options: masterOptions('workCategory') }, activeFilter]}
      searchPlaceholder="Work name or code"
      actions={add}
      rowTo={(i) => `/work-rates/${i._id}/edit`}
      rowActions={(i) => [
        { label: 'Edit rate', icon: 'edit', onClick: () => navigate(`/work-rates/${i._id}/edit`) },
        { label: 'Copy as new', icon: 'copy', onClick: () => navigate(`/work-rates/new?copy=${i._id}`) },
      ]}
      columns={[
        { header: 'Work', sort: 'name', render: (i) => <Cell title={i.name} sub={[i.itemCode, i.specification].filter(Boolean).join(' · ')} />, csv: (i) => i.name },
        { header: 'Category', sort: 'category', className: 'whitespace-nowrap', render: (i) => i.category || <span className="text-ink-300">-</span>, csv: (i) => i.category },
        { header: 'Unit', className: 'whitespace-nowrap', render: (i) => `per ${i.unit}`, csv: (i) => i.unit },
        { header: 'Rate', sort: 'sellingRate', sortDesc: true, align: 'right', render: (i) => <span className="font-semibold text-navy-900">{money(i.sellingRate)}</span>, csv: (i) => i.sellingRate / 100 },
        { header: 'GST', sort: 'gstRate', sortDesc: true, align: 'right', render: (i) => `${i.gstRate ?? 0}%`, csv: (i) => i.gstRate },
        { header: 'Rate with GST', align: 'right', render: (i) => money(withGst(i)), csv: (i) => withGst(i) / 100 },
        { header: 'SAC', sort: 'sacHsn', render: (i) => i.sacHsn || '-', csv: (i) => i.sacHsn, defaultHidden: true },
        { header: 'Status', sort: 'isActive', render: (i) => (i.isActive ? <Badge tone="green" dot>Active</Badge> : <Badge tone="grey" dot>Inactive</Badge>), csv: (i) => (i.isActive ? 'Active' : 'Inactive') },
      ]}
      mobile={(i) => ({ title: i.name, subtitle: [i.category, `per ${i.unit}`].filter(Boolean).join(' · '), right: money(i.sellingRate) })}
      empty={{ icon: 'wrench', title: 'No work rates yet', message: 'Add your rates for wiring points, fan fitting, DB work and repairs.', action: add }}
    />
  );
}
